import { Component, inject, input, output } from '@angular/core';
import { DialogService } from '@insolution/core-feature';
import { Announcement } from '@insolution/graphql-data-access';

@Component({
  selector: 'lib-confirm-delete-announcement',
  imports: [],
  templateUrl: './confirm-delete-announcement.html',
  styleUrl: './confirm-delete-announcement.scss',
})
export class ConfirmDeleteAnnouncement {
  public announcement = input.required<Announcement>();
  public delete = output<void>();

  private dialogService = inject(DialogService);

  public async openDeleteConfirm(): Promise<void> {
    const confirmed = await this.dialogService.openConfirm({
      titleTranslationLabel: 'announcement.confirm-delete.title',
      messageTranslationLabel: 'announcement.confirm-delete.message',
    });

    if (!confirmed) {
      return;
    }

    this.delete.emit();
  }
}
